import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@material-ui/core';
import { Typography } from '@orijinworks/frontend-commons';
import { ADD_FORMS_LABELS } from './addFormsModal.constants';

/** Loading spinner, catalog error, or empty-catalog message above the option list. */
const AddFormsStatus = ({ classes, loading, error, isEmpty }) => {
  if (loading) {
    return (
      <Box className={classes.status} data-testid="add-forms-loading">
        <CircularProgress size={24} />
      </Box>
    );
  }
  const message = error || (isEmpty ? ADD_FORMS_LABELS.EMPTY : null);
  if (!message) {
    return null;
  }
  return (
    <Box className={classes.status} data-testid="add-forms-status">
      <Typography variant="body2">{message}</Typography>
    </Box>
  );
};

AddFormsStatus.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
  isEmpty: PropTypes.bool,
};

AddFormsStatus.defaultProps = {
  loading: false,
  error: null,
  isEmpty: false,
};

export default AddFormsStatus;
